import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
    MatLegacyDialogConfig as MatDialogConfig, MatLegacyDialogModule, MatLegacyDialogRef,
} from '@angular/material/legacy-dialog';
import { appMatDialogDefaultConfig } from '../../../helper/helper';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { AppButtonModule } from '../../../dave-utils-module/app-button-module/app-button.module';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';

export type PriceComparisonLongInformationDialogComponentDialogReturnData = undefined;
export interface PriceComparisonLongInformationDialogComponentDialogData {
    arlInformation: string;
    arlLongInformation: string;
}

@Component({
  selector: 'app-price-comparison-longtext-dialog',
  standalone: true,
    imports: [CommonModule, MatLegacyFormFieldModule, MatLegacyDialogModule, FontAwesomeModule, MatLegacyInputModule, AppButtonModule, CdkDrag, CdkDragHandle],
  templateUrl: './price-comparison-longtext-dialog.component.html',
  styleUrls: ['./price-comparison-longtext-dialog.component.scss']
})
export class PriceComparisonLongtextDialogComponent {
    static readonly DefaultConfig: MatDialogConfig = {
        ...appMatDialogDefaultConfig,
        hasBackdrop: false,
        disableClose: true,
        minWidth: '30rem',
    };

    protected arlInformation: string;
    protected arlLongInformation: string;

    constructor(@Inject(MAT_DIALOG_DATA) dialogData: PriceComparisonLongInformationDialogComponentDialogData, private dialogRef: MatLegacyDialogRef<PriceComparisonLongtextDialogComponent, PriceComparisonLongInformationDialogComponentDialogReturnData>) {
        this.arlInformation = dialogData.arlInformation;
        this.arlLongInformation = dialogData.arlLongInformation;
    }
}
